/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  UnknownSkillActivation,
  UnknownSkillActivation$inboundSchema,
} from "./unknownskillactivation.js";

/**
 * A page of terminal skill activations without exact version attribution.
 */
export type ListUnknownSkillActivationsResult = {
  /**
   * Unknown activations in this page.
   */
  activations: Array<UnknownSkillActivation>;
  /**
   * Cursor for the next page; absent when exhausted.
   */
  nextCursor?: string | undefined;
};

/** @internal */
export const ListUnknownSkillActivationsResult$inboundSchema: z.ZodMiniType<
  ListUnknownSkillActivationsResult,
  unknown
> = z.pipe(
  z.object({
    activations: z.array(UnknownSkillActivation$inboundSchema),
    next_cursor: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listUnknownSkillActivationsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListUnknownSkillActivationsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListUnknownSkillActivationsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListUnknownSkillActivationsResult' from JSON`,
  );
}
